// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_5uY8O","description":"_2EtgB","input":"_1tQaA","header":"_3Jod6","body":"FGpxi","horizontalLine":"_2nC-a"};